import React from "react"
import { useCustomName, useSCIMResourceManagement } from "hooks"
import { DEPARTMENT_KEY } from "utils/customNameHelpers"

const DepartmentMembershipInstructions = () => {
  const {
    nameInSentence: departmentNameInSentence,
    pluralNameInSentence: departmentsNameInSentence,
  } = useCustomName(DEPARTMENT_KEY)

  const { departmentsManagedBySCIM } = useSCIMResourceManagement()

  if (departmentsManagedBySCIM) {
    return (
      <div className="text-xs text-dark">
        <p>Instructions:</p>
        <p className="mb-4">
          Your organization manages {departmentNameInSentence} memberships via SCIM user provisioning.
          Therefore, you may not add users to or remove users from a {departmentNameInSentence}.
        </p>
        <p className="mb-4">
          SCIM user provisioning places new {departmentNameInSentence} members in Segment A.
          You may move a user from one segment to another by dragging the user&apos;s avatar
          from one segment to another.
        </p>
        <p className="mb-4">
          If a user is already a member of a {departmentNameInSentence}, you may add the user to additional segments.
          You may also remove a user from segments, provided the user remains in at least one segment.
        </p>
        <p>
          If any {departmentNameInSentence} memberships appear incorrect, contact your internal support.
        </p>
      </div>
    )
  }

  return (
    <p className="text-xs text-dark">
      Instructions: Drag users from the list into their {departmentsNameInSentence}.
      Remove users by dragging their icons to the trash can.
    </p>
  )
}

export default DepartmentMembershipInstructions
